'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  box-shadow: \'0px 1px 3px 0px rgba(185,197,205,0.50)\';\n'], ['\n  box-shadow: \'0px 1px 3px 0px rgba(185,197,205,0.50)\';\n']);

var _input = require('@hixme-ui/input');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _input.InputBase.withComponent('select').extend(_templateObject);
//# sourceMappingURL=SelectBase.js.map


//////////////////
// WEBPACK FOOTER
// ../select/lib/SelectBase.js
// module id = 709
// module chunks = 0